import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';
import FlyingElements from '../components/FlyingElements';
import CRMDashboardSVG from '../components/CRMDashboardSVG';

const CRMPanels = () => {
  const { theme } = useTheme();
  const effectiveVariant = theme;
  
  const variants = {
    light: 'bg-afsc-offwhite text-afsc-charcoal',
    dark: 'bg-afsc-slate text-white',
  };

  return (
    <section
      id="crm-panels"
      className={`py-20 md:py-32 ${variants[effectiveVariant]} relative overflow-x-hidden`}
    >
      {/* Center gradient overlay */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: effectiveVariant === 'dark' 
            ? 'radial-gradient(ellipse at center, rgba(203, 163, 90, 0.15) 0%, transparent 70%)'
            : 'radial-gradient(ellipse at center, rgba(203, 163, 90, 0.12) 0%, transparent 70%)',
        }}
      />
      <FlyingElements count="few" />
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30, filter: 'blur(10px)' }}
          whileInView={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="w-full"
        >
          <CRMDashboardSVG />
        </motion.div>
      </div>
    </section>
  );
};

export default CRMPanels;

